import {
  Facebook,
  Instagram,
  Twitter,
  Search,
  Update,
  CheckCircle,
  Cancel,
  AddCircle,
  Clear,
  Send,
} from "@mui/icons-material"

export const icons = (icon) => {
  switch (icon) {
    case "instagram":
      return <Instagram />
    case "twitter":
      return <Twitter />
    case "facebook":
      return <Facebook />
    case "search":
      return <Search />
    case "update":
      return <Update color="primary" fontSize="large" />
    case "check":
      return <CheckCircle color="success" fontSize="large" />
    case "cancel":
      return <Cancel color="error" fontSize="large" />
    case "add":
      return <AddCircle color="primary" fontSize="large" />
    case "clear":
      return <Clear />
    case "send":
      return <Send />
    default:
      return ""
  }
}

export default icons
